import { render, staticRenderFns } from "./PerceptorSection.vue?vue&type=template&id=2dff3b5a"
import script from "./PerceptorSection.vue?vue&type=script&lang=js"
export * from "./PerceptorSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports